import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import screen from 'superior-mq';
import Container from '../../container';
import Grid from '../../grid';
import Waves from '../../waves';
import ProgramDonate from '../../program/program-donate';
import StaggerIn from '../../stagger-in';

const gridStyles = `
  margin-top: 50px;

  ${screen.below(bp.mobile, `
    grid-gap: 0;
  `)};
`;

const DetailStatus = ({
  title,
  stats,
  isDark,
  inputIsDark,
  waveColor,
  showDonation,
  id,
}) => {
  if (stats.length < 1) return null;

  return (
    <StatusSection isDark={isDark}>
      <DetailContainer>

        <Headline>{title}</Headline>
        <StaggerIn>
          <Grid styles={gridStyles}>

            {stats.map((stat, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <StatusGridItem span={4} className="js-stagger" isDark={isDark} key={i}>
                <StatusHeading isDark={isDark}>{stat.value}</StatusHeading>
                <StatusSpan>{stat.title}</StatusSpan>
              </StatusGridItem>
            ))}

            <WaveWrapper>
              <Waves
                position="bottom"
                alignment="bottom"
                height={260}
                color={waveColor}
                inverted
                styles="bottom: -55px"
              />
            </WaveWrapper>

          </Grid>
        </StaggerIn>
        {showDonation &&
          <Fragment>
            <Headline>Make a Contribution</Headline>
            <ProgramDonate id={id} isDark={inputIsDark} />
          </Fragment>
        }

      </DetailContainer>
    </StatusSection>
  );
};

const StatusSection = styled.section`
  position: relative;
  overflow: hidden;
  padding-bottom: 100px;
  color: ${props => props.isDark ? '#fff' : '#000'};
  background-color: ${props => props.isDark ? '#073342' : '#fff'};

  ${screen.below(bp.mobile, `
     padding-bottom: 65px;
  `)};
`;

const WaveWrapper = styled.div`
  ${screen.above(bp.desktop, `
    margin-top: 30px;
  `)};

  ${screen.below(bp.mobile, `
    display: none;
  `)};
`;

const Headline = styled.h4`
  padding-top: 100px;

  ${screen.below(bp.mobile, `
    padding-top: 50px;
  `)};
`;

const DetailContainer = styled(Container)`
  text-align: center;
  border-top: 3px solid ${props => props.theme.lighterBlue};
`;

const StatusHeading = styled.h4`
  margin-bottom: 15px;
  color: ${props => props.isDark ? props.theme.blue : '#000'};

  ${screen.below(bp.mobileSm, `
    font-size: ${rem(18)};
  `)}
`;

const StatusGridItem = styled(Grid.Item)`
  padding: 128px 0 121px;
  background-color: ${props => props.isDark ? props.theme.black : props.theme.lightGray};

  ${screen.below(bp.tablet, `
    padding: 75px 0;
  `)};

  ${screen.below(bp.mobile, `
    padding: 30px 0;
    background-color: ${props => props.isDark ? props.theme.black : '#fff'};

    &:not(:first-of-type) {
      border-left: 1px solid #474747;
    }
  `)};
`;

const StatusSpan = styled.span`
  display: block;

  ${screen.below(bp.mobile, `
    font-size: ${rem(11)};
    line-height: ${rem(12)};
  `)};

  ${screen.below(bp.mobileSm, `
    max-width: 50px;
    margin: auto;
  `)}
`;

DetailStatus.propTypes = {
  title: PropTypes.string,
  isDark: PropTypes.bool,
  waveColor: PropTypes.string,
  stats: PropTypes.array,
  inputIsDark: PropTypes.bool,
  showDonation: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DetailStatus.defaultProps = {
  waveColor: '#fff',
  stats: [],
};

export default DetailStatus;
